module.exports = __webpack_public_path__ + "img/46.7f1edc07.jpg";